import React, { useState, useRef } from 'react';
import { ExclamationCircleFilled, MinusCircleOutlined, PlusOutlined, CloseOutlined, CheckOutlined } from '@ant-design/icons';
import { Divider, Empty, Table, Button, Col, Tag, Drawer, Form, Input, Row, Select, Space, message, Modal, Typography, Switch  } from 'antd';
import {insert, update, getById, getDetailsById, dropDetail} from '../../../../apis/CalculosApi';
import moment from 'moment';
import './Edit.scss';
import Details from './Details'
const { Title } = Typography;
const { confirm } = Modal;

const formItemLayout = {
    labelCol: {
        xs: {
            span: 24,
        },
        sm: {
            span: 4,
        },
    },
    wrapperCol: {
        xs: {
            span: 24,
        },
        sm: {
            span: 20,
        },
    },
};
const formItemLayoutWithOutLabel = {
wrapperCol: {
    xs: {
    span: 24,
    offset: 0,
    },
    sm: {
    span: 20,
    offset: 4,
    },
},
};

const App = ({title, id, open, finish}) => {
    const [ form ] = Form.useForm()
    const [ID, setID] = useState(id);
    const [columns, setColumns] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [dataDetails, setDataDetails] = useState([]);
    const [openNewDetails, setOpenNewDetails] = useState(false);
    const [selectedDetail, setSelectedDetail] = useState(null);
    const [searchText, setSearchText] = useState("");
    const [searchedColumn, setSearchedColumn] = useState("");
    const [initialValues, setInitialValues] = useState(null);
    const searchInput = useRef(null);
    const [initialTags, setInitialTags] = useState([]);
    const [definicion, setDefinicion] = useState([]);
    const [disabled, setDisabled] = useState(false);
    const [pageSize, setPageSize] = useState(10);
     
    var _columns = [
        {
          title: 'Clave',
          dataIndex: 'clave',
          key: 'clave',
        },
        {
          title: 'Fecha Inicial',
          dataIndex: 'fecha_inicial',
          key: 'fecha_inicial',
        }
    ];

    const handleOk = async () => {
        let fields = await setObjectDefinicion();
        let success = false;
        if(ID > 0){
            //Update
            const payload = {
                id: ID,
                activo: true,
                ...fields,
            }
            const response = await update(payload);
            success = response.ok;
            if(response.ok){
                message.success('Se actualizó correctamente la definición!');
            }
        }else{
            //Create
            const payload = {
                id: ID,
                activo: true,
                ...fields,
            }
            const response = await insert(payload);
            success = response.ok;
            if(response.ok){
                setID(response.payload);
                message.success('Se guardo correctamente la definición!');
            }
        }

        if(success){
            finish(true, true);
        }
    }

    const setObjectDefinicion = async ()=> {
        const fields = form.getFieldsValue();
        let returnValue = {...fields};
        var tags = [];
        for (let index = 0; index < fields.etiquetas?.length; index++) {
            const tag = fields.etiquetas[index];
            const initialTag = initialTags[index];
            tags.push({index: index, tag: tag, name: initialTag?.name});
        }
        let etiquetas = JSON.stringify(tags);
        let payload = {...definicion, etiquetas};
        setDefinicion(payload);
        returnValue.etiquetas = etiquetas;
        return returnValue;
    }

    const onClickNewDetail = async ()=>{
        await setObjectDefinicion();
        setOpenNewDetails(true);
        setSelectedDetail(null);
    }

    const onClose = ()=>{
        setShowModal(false);
        finish(false);
        setInitialValues(null);
    }

    const finishDetail = async () => {
        setOpenNewDetails(false);
        await refreshDetails();
    }

    React.useEffect(() => {
        setShowModal(open);
    }, [open]);

    const effectRan = useRef(false);
    React.useEffect(() => {
      if (!effectRan.current) {
        (async () => {
          if(ID > 0){
            await refreshData();
            await refreshDetails();
          }else{
            setInitialValues({
              descripcion: '',
              clave: '',
              cuenta_balance: '',
            });
          }
        })();
      }
      return () => effectRan.current = true;
    }, []);

    // React.useEffect(() => {
    //     (async () => {
    //         if(ID > 0){
    //             await refreshData();
    //             await refreshDetails();
    //         }
    //     })();
    //   }, [ID]);

    const refreshData = async ()=> {
        const response = await getById(ID);
        if(response.ok){
            let _definicion = response.payload;
            var tags = [];
            var names = [];
            var etiquetas = JSON.parse(_definicion?.etiquetas) || [];
            setInitialTags([...etiquetas])
            for (let index = 0; index < etiquetas?.length; index++) {
                const item = etiquetas[index];
                tags.push(item.tag);
                _columns.push( {
                    title: item.tag,
                    dataIndex: item.name,
                    key: item.name,
                  })
            }

            _columns.push(
                {
                    title: '',
                    dataIndex: 'actions',
                    key: 'actions',
                    render: (item, object)=> {
                      return <Space>
                        <Button type='primary' size='small' onClick={()=>{
                            setOpenNewDetails(true);
                            setSelectedDetail(object);
                        }}>Editar</Button>
                        <Button type='primary' size='small' danger onClick={()=>{
                            deleteConfirm(object);
                        }}>Eliminar</Button>
                      </Space>
                    }
                }
            );
            setColumns(_columns);
            _definicion.etiquetas = tags;
            setInitialValues(_definicion);
            setDefinicion(_definicion);
        }
    }

    const refreshDetails = async ()=> {
      const response = await getDetailsById(ID);
      if(response.ok){
        let list = response.payload;
        for (let index = 0; index < list?.length; index++) {
            let detail = list[index];
            if(detail.fecha_inicial){
                detail.fecha_inicial = moment(detail.fecha_inicial).format('YYYY-MM-DD');
            }

            var valores = JSON.parse(detail?.valores) || [];
            for (let j = 0; j < valores?.length; j++) {
                var valor = valores[j];
                detail[valor.name] = valor.value;
            }
        }
        setDisabled(list?.length > 0);
        setDataDetails(list);
      }
    }

    const deleteConfirm = async (item) => {
        confirm({
            title: '¿Confirmas en eliminar el detalle?',
            icon: <ExclamationCircleFilled />,
            content: 'No podrás recuperar su información',
            onOk: ()=>{deleteOk(item.id)},
            onCancel() {
                console.log('Cancel');
            },
        });
    }
    
    const deleteOk = async (id)=>{
        const response = await dropDetail(id);
        if(response.ok){
            message.success('¡El detalle ha sido eliminadó!');
            await refreshDetails();
        }
    }

    const handleTableChange = (pagination) => {
        setPageSize(pagination.pageSize);
    };

    return (
      <Drawer
        title={<>
          { ID > 0 ? '(' + ID + ') ': ''} 
          {title}
        </>}
        width={'100%'}
        placement={"right"}
        onClose={onClose}
        open={open}
        closable={true}
        height={'100%'}
        styles={{
          body: {
            paddingBottom: 80,
          },
        }}
        extra={[
          <Space>
            <Button onClick={onClose}>Cancelar</Button>
            <Button onClick={handleOk} type="primary">
            Guardar
            </Button>
          </Space>
        ]}
      >
        <>
            <div>
                <div style={{float: 'left'}}>
                    <span title=""></span>
                </div>
                <span class="" style={{float:'right'}}>
                </span>
            </div>
            {/* <PageHeader ghost={false} title="Remisiones" extra={[ 
            <Space>
                <Button onClick={onClose}>Cancelar</Button>
                <Button onClick={handleOk} type="primary">
                Guardar
                </Button>
            </Space>]} />*/}
        {
            initialValues && <>
                <Form layout="vertical" disabled={disabled}
                    form={form} requiredMark initialValues={initialValues} onFinish={handleOk} >
                    <Row gutter={16}>
                        <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                            <Form.Item
                                name="clave"
                                label="Clave"
                                rules={[
                                {
                                    required: true,
                                    message: 'Por favor agrega la clave',
                                },
                                ]}>
                                <Input placeholder="Por favor agrega la clave" style={{width: '80%',}}/>
                            </Form.Item>
                        </Col>
                        <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                            <Form.Item
                                name="descripcion"
                                label="Descripcion"
                                rules={[
                                {
                                    required: true,
                                    message: 'Por favor agrega una descripion',
                                },
                                ]}>
                                <Input placeholder="Por favor agrega una descripion" style={{width: '80%',}}/>
                            </Form.Item>
                        </Col>
                        <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                            <Form.Item
                                name="activo"
                                label="Activo"
                                >
                                <Switch checkedChildren={<CheckOutlined />} unCheckedChildren={<CloseOutlined />}/>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={24}>
                            <Divider orientation="left">Etiquetas</Divider>
                        </Col>
                        <Form.List
                            name="etiquetas"
                        >
                            {(fields, { add, remove }, { errors }) => (<>
                                <Row gutter={16} style={{width: '100%', alignItems: 'flex-start'}}>
                                {fields.map((field, index) => (
                                <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}} key={field.key}>
                                    <Form.Item
                                        required={false}
                                    >
                                        <Form.Item
                                        {...field}
                                        validateTrigger={['onChange', 'onBlur']}
                                        rules={[
                                            {
                                            required: true,
                                            whitespace: true,
                                            message: "Por favor, agrega el nombre de la etiqueta.",
                                            },
                                        ]}
                                        noStyle
                                        >
                                            <Input
                                                placeholder={'Etiqueta ' + (index+1)}
                                        />
                                        </Form.Item>

                                        {fields.length > 1 && !disabled ? (
                                        <MinusCircleOutlined
                                            className="dynamic-delete-button"
                                            onClick={() => remove(field.name)}
                                            style={{marginLeft: 8}}
                                        />
                                        ) : null}
                                    </Form.Item>
                                </Col>))}
                                </Row>
                                <Col md={{span: 24}} sm={{span: 24}} xs={{span: 24}}>
                                    <Form.Item>
                                        <Button
                                            type="dashed"
                                            onClick={() => add()}
                                            icon={<PlusOutlined />}
                                        >
                                            Agregar Etiqueta
                                        </Button>
                                        <Form.ErrorList errors={errors} />
                                    </Form.Item>
                                </Col>
                            </>
                            )}
                        </Form.List>
                    </Row>
                </Form>
                <Divider></Divider>
                <div style={{height: 60}}>
                    <div style={{float: 'left'}}>
                        <Title level={2}>Detalles</Title>
                    </div>
                    <span class="" style={{float:'right'}}>
                        <Space>
                            <Button disabled={!ID} onClick={onClickNewDetail} type="primary" style={{marginBottom: 10}}>Agregar nuevo detalle</Button>
                        </Space>
                    </span>
                </div>
                {
                    openNewDetails && 
                    <div style={{marginBottom: 10}}>
                        {
                            !selectedDetail &&
                            <Details title="Agregar detalle" definicionId={ID} definicion={definicion} finish={finishDetail} open={openNewDetails}/>
                        }
                        {
                            selectedDetail &&
                            <Details title="Editar detalle" definicionId={ID} definicion={definicion} id={selectedDetail.id} finish={finishDetail} open={openNewDetails}/>
                        }
                    </div>
                }
                {/* <Button disabled={!ID} onClick={onClickNewDetail} type="primary" style={{marginBottom: 10}}>Agregar nuevo detalle</Button> */}
                {
                    dataDetails.length === 0 ? <Empty /> :
                    <Table 
                        dataSource={dataDetails} 
                        columns={columns}
                        pagination={{
                            pageSize: pageSize,
                            showSizeChanger: true,
                            showTotal: (total) => `Total ${total} detalles`,
                            pageSizeOptions: ['10', '20', '50', '100'],
                        }}
                        onChange={handleTableChange}
                    />
                }
            </>
        }

        
        </>
    </Drawer>
  );
};
export default App;